import React from "react";
import "../CSS/Home.css"


const Home = () => {
    return(
        <div>
            <h1>Welcome!</h1>
    
            <div className='container'>
                <p className='text'>
                    Hi there! I hope this website helps to get to know me a little bit better.
                    Is there anything you are wondering about but you don't seem to be able to find it here?
                    Please don't hesitate to reach out using any of the communication channels you can find under 
                    Contact menu section.
                </p>
                <img className='imagen' alt='' src={require('../Static/profile_pic.png')}></img>
            </div>

        </div>
    )
}

export default Home;



// WEBPACK FOOTER //
// ./src/Components/Home.js